// loader.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  isLoading = new BehaviorSubject<boolean>(false);
  private requestCount = 0;
  private forceDisabled = false;

  show() {
    if (this.forceDisabled) return; // Respect manual disabling
    this.requestCount++;
    this.isLoading.next(true);
  }

  hide() {
    if (this.forceDisabled) return; // Still respect manual disabling
    this.requestCount--;
    if (this.requestCount <= 0) {
      this.requestCount = 0; // Prevent negative count
      this.isLoading.next(false);
    }
  }

  disable() {
    this.forceDisabled = true;
    this.requestCount = 0; // Reset counter so hide() won't misfire
    this.isLoading.next(false);
  }

  enable() {
    this.forceDisabled = false;
  }
}

